(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5929],{

/***/ 13377:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews",
      function () {
        return __webpack_require__(32218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ reviews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/core/SEO/Reviews/structuredData.tsx
var structuredData = function(reviews) {
    return JSON.stringify({
        "@context": "https://schema.org/",
        "@graph": reviews.map(function(e, _, arr) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var images = (ref = e.product) === null || ref === void 0 ? void 0 : ref.images.map(function(image) {
                return new URL(image.url);
            });
            return {
                "@type": "Review",
                author: {
                    "@type": "Person",
                    name: e.fullName
                },
                itemReviewed: {
                    "@type": "Product",
                    brand: "Reno",
                    image: images,
                    manufacturer: "Reno sp zoo",
                    name: ((ref1 = e.product) === null || ref1 === void 0 ? void 0 : ref1.name) ? (ref2 = e.product) === null || ref2 === void 0 ? void 0 : ref2.name : "sliding doors",
                    productID: ((ref3 = e.product) === null || ref3 === void 0 ? void 0 : ref3.slug) ? (ref4 = e.product) === null || ref4 === void 0 ? void 0 : ref4.slug : "sliding-doors",
                    sku: ((ref5 = e.product) === null || ref5 === void 0 ? void 0 : ref5.slug) ? (ref6 = e.product) === null || ref6 === void 0 ? void 0 : ref6.slug : "sliding-doors"
                },
                datePublished: e.createdAt,
                name: e.title,
                reviewBody: e.description,
                reviewRating: {
                    "@type": "Rating",
                    bestRating: arr.reduce(function(max, val) {
                        var sum = max;
                        if (val.rating > sum) {
                            sum = val.rating;
                        }
                        return sum;
                    }, 0),
                    ratingValue: e.rating,
                    worstRating: arr.reduce(function(min, val) {
                        var sum = min;
                        if (val.rating < sum) {
                            sum = val.rating;
                        }
                        return sum;
                    }, 5)
                }
            };
        })
    });
};

// EXTERNAL MODULE: ./src/@next/components/atoms/Loader/index.ts + 2 modules
var Loader = __webpack_require__(35582);
// EXTERNAL MODULE: ./src/@next/pages/NotFound/index.tsx + 2 modules
var NotFound = __webpack_require__(85666);
// EXTERNAL MODULE: ./src/@next/utils/regions.ts + 1 modules
var regions = __webpack_require__(8044);
// EXTERNAL MODULE: ./src/@next/utils/tsUtils.ts
var tsUtils = __webpack_require__(5946);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/core/config.ts + 15 modules
var config = __webpack_require__(42443);
// EXTERNAL MODULE: ./src/views/Reviews/Page.tsx + 27 modules
var Page = __webpack_require__(5862);
;// CONCATENATED MODULE: ./src/views/Reviews/View.tsx















var View = function(param) {
    var seo = param.seo;
    var ref = (0,react.useState)(true), hasImages = ref[0], setHasImages = ref[1];
    var locale = (0,router.useRouter)().locale;
    var ref1 = (0,generatedHooks/* useReviewsQuery */._s)({
        variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            hasImages: hasImages
        }, (0,regions/* localeToSaleorQuery */.KK)(locale)), {
            pageSize: config/* REVIEWS_PER_PAGE */.TJ
        })
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore, networkStatus = ref1.networkStatus;
    var isRefetching = networkStatus === 3;
    var onLoadMore = function() {
        var ref;
        fetchMore({
            variables: {
                after: data === null || data === void 0 ? void 0 : (ref = data.reviews) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
            }
        });
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
    }
    if (data && data.reviews === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {});
    }
    var reviews = data.reviews.edges.map(function(param) {
        var node = param.node;
        return node;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: structuredData(reviews)
                    }
                }, "reviews-jsonld")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                hasImages: hasImages,
                setHasImages: setHasImages,
                loading: isRefetching,
                canLoadMore: (0,tsUtils/* maybe */.w)(function() {
                    return data.reviews.pageInfo.hasNextPage;
                }, false),
                reviews: reviews,
                onLoadMore: onLoadMore
            })
        ]
    });
};
/* harmony default export */ var Reviews_View = (View);

;// CONCATENATED MODULE: ./src/views/Reviews/index.tsx


;// CONCATENATED MODULE: ./src/pages/reviews/index.ts

var __N_SSG = true;
/* harmony default export */ var reviews = (Reviews_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6885,2962,2908,9774,2888,179], function() { return __webpack_exec__(13377); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);